import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import { Styled } from './styled';

export interface MessageBubbleProps extends HTMLAttributes<HTMLDivElement> {
  readonly type: 'sender' | 'replier';
  readonly showTail?: boolean;
}

export function MessageBubble({
  type,
  showTail = true,
  className,
  children,
  ...props
}: MessageBubbleProps): JSX.Element {
  return (
    <Styled
      className={classNames(MessageBubble.displayName, type, showTail ? 'tail' : '', className)}
      {...props}
    >
      {children}
    </Styled>
  );
}
MessageBubble.displayName = 'MessageBubble';
